import _ from "lodash";
import { HttpService } from "@/core";
import {
  ProfilePageReq,
  ProfilePageResp,
  ProfileSimpleListReq,
  projectStatusReq,
  ProfileDetailResp,
  ProfileReq,
  TeamTypeEnum,
  Cooperation,
  ThrowSingleApiSubmitReq,
  ProjectItem,
} from "./profile.interface";

export class ProfileService {
  static usePageApi() {
    const api = (params: ProfilePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/project/page",
        params,
      });
    return HttpService.usePagination<ProfilePageResp>(api);
  }

  static async useGetIdApi(data) {
    return await HttpService.axios({
      method: "post",
      url: "/projectOverAll/decideHadHave",
      data,
    });
  }

  // 360视图获取top数值
  static useGetTopApi() {
    const api = (data) =>
      HttpService.axios({
        method: "post",
        url: "/projectOverAll/top",
        data,
      });
    return HttpService.useRequest<any>(api);
  }

  static useSimpleListApi() {
    const api = (params: ProfileSimpleListReq, url = "/project/simple/list") =>
      HttpService.axios({
        method: "GET",
        url,
        params,
      });
    return HttpService.usePagination<ProjectItem>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project/${id}`,
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ProfileReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project",
        data: ProfileService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }
  // 一键审批
  static useCreateApis() {
    const api = (data: ProfileReq) =>
      HttpService.axios({
        method: "POST",
        url: "/project/add_new",
        data: ProfileService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }
  static useEditApi() {
    const api = (id: string, data: ProfileReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/project/${id}`,
        data: ProfileService.profileReqToAjaxData(data),
      });
    return HttpService.useRequest<ProfileDetailResp>(api);
  }
  // 项目状态新增或删除
  static addOrRemoveApi() {
    const api = (data: projectStatusReq) =>
      HttpService.axios({
        method: "POST",
        url: `project/addOrRemove/status`,
        data,
      });
    return HttpService.useRequest<any>(api);
  }
  // 当前所勾选状态列表
  static projectStatusList() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: `project/status/list`,
      });
    return HttpService.useRequest<any>(api);
  }

  // 根据项目id查找往来公司
  static useFindCompanyApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "get",
        url: `/project/${id}/lastCompany`,
      });
    return HttpService.useRequest<Cooperation>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/project/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  // 根据项目 ID 查找合同金额
  static useAmountApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/project/${id}/amount`,
      });
    return HttpService.useRequest<{ projectAmount: number }>(api);
  }

  static useThrowSingleApi() {
    const api = (data: ThrowSingleApiSubmitReq) =>
      HttpService.axios({
        method: "POST",
        url: `/throw_single`,
        data,
      });
    return HttpService.useRequest<void>(api, { isOutError: true });
  }

  static profileReqToAjaxData(req: ProfileReq) {
    req = _.cloneDeep(req);
    const {
      customerCooperationCompanyId,
      customerContacts,
      customerMobile,
      bizManId,
      customerManagerId,
      projectManagerId,
      tenderOwnerId,
      designOwnerId,
      ...rest
    } = req;
    const customer = {
      cooperationCompanyId: customerCooperationCompanyId,
      contacts: customerContacts,
      mobile: customerMobile,
    };
    const teams = [
      { tenantUserId: bizManId, type: TeamTypeEnum.BIZ_MAN },
      { tenantUserId: customerManagerId, type: TeamTypeEnum.CUSTOMER_MANAGER },
      { tenantUserId: projectManagerId, type: TeamTypeEnum.PROJECT_MANAGER },
      { tenantUserId: tenderOwnerId, type: TeamTypeEnum.TENDER_OWNER },
      { tenantUserId: designOwnerId, type: TeamTypeEnum.DESIGN_OWNER },
    ].filter((item) => !!item.tenantUserId);
    return {
      ...rest,
      customer,
      teams,
    };
  }

  static detailRespToProfileReq(resp: ProfileDetailResp): ProfileReq {
    const { customer, teams, ...rest } = resp;
    const req = new ProfileReq();
    req.pick(rest);

    const temp = {
      customerCooperationCompanyId: customer?.cooperationCompanyId,
      customerContacts: customer?.contacts,
      customerMobile: customer?.mobile,
      bizManId: "",
      customerManagerId: "",
      projectManagerId: "",
      tenderOwnerId: "",
      designOwnerId: "",
    };
    (teams || []).forEach((team) => {
      const type = +team.type;
      if (type === TeamTypeEnum.BIZ_MAN) {
        temp.bizManId = team.tenantUserId;
      }
      if (type === TeamTypeEnum.CUSTOMER_MANAGER) {
        temp.customerManagerId = team.tenantUserId;
      }
      if (type === TeamTypeEnum.PROJECT_MANAGER) {
        temp.projectManagerId = team.tenantUserId;
      }
      if (type === TeamTypeEnum.TENDER_OWNER) {
        temp.tenderOwnerId = team.tenantUserId;
      }
      if (type === TeamTypeEnum.DESIGN_OWNER) {
        temp.designOwnerId = team.tenantUserId;
      }
    });
    req.merge(temp);
    return req;
  }
}
